















































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import AccountDepositFixedTermMaturityValues from '@/models/Accounts/DepositAccounts/Values/AccountDepositFixedTermMaturityValues';

@Component({ name: 'AccountDepositFixedTermMaturityValuesRead' })
export default class extends SaascadaVueFieldGroup {

    @Prop({required: true })
    values: AccountDepositFixedTermMaturityValues;

}
